import { SelectButtonProps } from 'primevue';

export enum SplitButtonSizes {
  SMALL = 'small',
  BIG = 'big',
}

export type SplitButtonProps = SelectButtonProps & {
  size?: `${SplitButtonSizes}`;
};
